import { render } from "./OwnerPrenotationsPage.vue?vue&type=template&id=d28c9670&scoped=true"
import script from "./OwnerPrenotationsPage.vue?vue&type=script&lang=js"
export * from "./OwnerPrenotationsPage.vue?vue&type=script&lang=js"

import "./OwnerPrenotationsPage.vue?vue&type=style&index=0&id=d28c9670&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28c9670"]])

export default __exports__